module.exports = __webpack_public_path__ + "img/COMBO HEART BW.3d7232e.svg";